<template>
  <div class="wrapper">
    <cube-form :model="model"
               @submit.prevent="submitHandler">
      <cube-form-group v-if="!hideRelationField">
        <cube-form-item :field="fields[0]"></cube-form-item>
      </cube-form-group>
      <cube-form-group>
        <cube-form-item :field="fields[1]"></cube-form-item>
      </cube-form-group>
      <cube-form-group>
        <cube-form-item :field="fields[2]"></cube-form-item>
      </cube-form-group>
      <cube-form-item class="custom-item"
                      :field="fields[3]">
        <cube-button class="custom-button"
                     :class="{'no-value':model.birthday.length === 0}"
                     @click="showDatePicker">{{model.birthday || '出生日期'}}</cube-button>
      </cube-form-item>
      <cube-form-group v-if="model.relation != 0">
        <cube-form-item :field="fields[8]" class="small"></cube-form-item>
      </cube-form-group>
      <cube-form-item class="custom-item"
                      :field="fields[4]">
        <cube-button class="custom-button"
                     :class="{'no-value':model.address.length === 0}"
                     @click="showCityPicker">{{model.address || '选择城市'}}</cube-button>
      </cube-form-item>
      <cube-form-group v-if="!hideAddressField">
        <cube-form-item :field="fields[5]"></cube-form-item>
      </cube-form-group>
      <cube-form-group>
        <cube-form-item class="custom-item single"
                        :field="fields[6]"></cube-form-item>
        <textarea rows="8"
                  cols="30"
                  placeholder="为了让医生详细了解您的症状，请务必仔细填写“病情描述”(如:症状,病情持续时间,是否有家庭遗传,药物过敏等 30字以上)"
                  v-model="model.content">
        </textarea>

      </cube-form-group>
      <cube-form-group>
        <cube-form-item class="custom-item single"
                        :field="fields[7]"></cube-form-item>
        <div class="image-box">
          <div v-for="(item, index) in imgs" :key="item" class="img up">
            <span class="del iconfont icon-shanchu" @click.prevent="delImage(index)"></span>
            <img :src="item" alt="" @click="showImagePreview(index)">
          </div>
          <div class="img" v-show="_selectShow">
            <image-up :imageChange='onImageChange'></image-up>
          </div>

        </div>

      </cube-form-group>
      <!-- <cube-form-group> -->
      <div class="submit-button">
        <cube-button class="button"
                     type="submit">提交</cube-button>
      </div>

      <!-- </cube-form-group> -->
    </cube-form>
  </div>
</template>

<script>
import { qiniuUrl } from '@/common/js/utils'
import { getQinToken, getRelationForSelf, getPurpose, addPatient } from '@/api/yuyueApi'
import { getKey, getCacheObject } from '@/common/js/cache'
import imageUp from '@/components/image_up.vue'
import md5 from 'js-md5'

const cityData = require('@/assets/city.json')
const qiniu = require('qiniu-js')
const MAX_IMG_COUNT = 20
let qinToken = null
let orderId = ''

export default {
  name: 'editinfo',
  components: {
    imageUp
  },
  props: {},
  data () {
    return {
      imgs: [],
      model: {
        relation: '',
        gender: '',
        birthday: '',
        content: '',
        address: '',
        purpose: '',
        imgs: '',
        relationPhone: '',
        realname: ''
      },
      hideRelationField: false,  // 控制是否隐藏关系字段
      hideAddressField: false ,
      fields: [
        {
          type: 'select',
          modelKey: 'relation',
          label: '实际咨询人是您的',
          props: {
            options: []
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'realname',
          label: '实际咨询人姓名',
          props: {
            placeholder: '请输入咨询人姓名'
          },
          rules: {
            required: true,
            pattern: /^[\u4e00-\u9fa5]+$/
          },
          messages: {
            required: '请输入中文'
          }
        },
        {
          type: 'select',
          modelKey: 'gender',
          label: '请选择性别',
          props: {
            options: [{
              value: '1',
              text: '女'
            }, {
              value: '0',
              text: '男'
            }]
          },
          rules: {
            required: true
          }
        },
        {
          modelKey: 'birthday',
          label: '请选择出生年月日',
          rules: {
            required: true
          }
        },
        {
          modelKey: 'address',
          label: '实际咨询人居住城市',
          rules: {
            required: true
          }
        },
        {
          type: 'select',
          modelKey: 'purpose',
          label: '本次视频目的',
          props: {
            options: [0]
          },
          rules: {
            required: true
          }
        },
        {
          modelKey: 'content',
          label: '病情描述(30个字以上)',
          rules: {
            required: true,
            pattern: /[\s\S]{30,}/
          },
          messages: {
            required: '请输入至少30个字'
          }
        },
        {
          modelKey: 'imgs',
          label: '点击下方上传更多信息(最多20张图片)',
          rules: {
            required: true,
            pattern: /.{1,}/
          },
          messages: {
            required: '请上传至少1张图'
          }
        },
        {
          type: 'input',
          modelKey: 'relationPhone',
          label: '实际咨询人手机号',
          props: {
            placeholder: '方便医助联络实际咨询人'
          },
          rules: {
            required: true,
            pattern: /^1[3456789]\d{9}$/
          },
          messages: {
            required: '请输入手机号'
          }
        }
      ]
    }
  },
  watch: {
    imgs (val) {
      this.model.imgs = val.join(',')
    },
    'model.realname' (val) {
      this.model.realname = val.replace(/\s*/g, '')
    },
    'model.relationPhone' (val) {
      this.model.relationPhone = val.replace(/\s*/g, '')
    }
  },
  computed: {
    _selectShow () {
      return this.imgs.length < MAX_IMG_COUNT
    }
  },
  methods: {
    async submitHandler (e) {
      const params = {
        ...this.model,
        orderId
      }
      if (this.model.relation === '0') {
        params.relationPhone = ''
      }
      console.log(params)
      const res = await addPatient(params)
      if (res.reason) {
        this.$router.replace({
          path: '/orderInfo',
          query: {
            orderId: res.reason
          }
        })
      } else {
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: res.message
        }).show()
      }
    },
    submit () {
      console.log('submit')
    },
    validateHandler (result) {
      this.validity = result.validity

      this.valid = result.valid
     
    },
    showDatePicker () {
      if (!this.formatPicker) {
        this.formatPicker = this.$createDatePicker({
          title: '请选择出生年月日',
          min: new Date(1920, 1, 1),
          max: new Date(),
          value: new Date(2020, 1, 1),
          format: {
            year: 'YYYY年',
            month: 'MM月',
            date: 'DD日'
          },
          onSelect: this.selectHandle
        })
      }

      this.formatPicker.show()
    },
    selectHandle (date, selectedVal, selectedText) {
      this.model.birthday = selectedText.join('')
    },
    showCityPicker () {
      const citys = []
      for (let index = 0; index < cityData.length; index++) {
        const city = cityData[index]
        const children = []
        const item = {
          value: city.state,
          text: city.state,
          children
        }
        for (let j = 0; j < city.cities.length; j++) {
          const city2 = city.cities[j]
          children.push({
            value: city2.city,
            text: city2.city
          })
        }
        citys.push(item)
      }
      if (!this.cityPicker) {
        this.cityPicker = this.$createCascadePicker({
          title: '城市选择',
          data: citys,
          onSelect: this.selectCityHandler
        })
      }

      this.cityPicker.show()
    },
    selectCityHandler (selectedVal, selectedIndex) {
      this.model.address = selectedVal.join('-')
    },

    delImage (index) {
      this.imgs.splice(index, 1)
    },
    showImagePreview (index) {
      this.$createImagePreview({
        imgs: this.imgs,
        initialIndex: index
      }).show()
    },
    async onImageChange (name, file) {
      const token = await this.getToken()
      const options = {
        quality: 0.92,
        noCompressIfLarger: true,
        maxWidth: 1500
      }
      const key = md5(file.name + Date.now() + Math.random * 10000000)
      qiniu.compressImage(file, options).then(data => {
        const observable = qiniu.upload(data.dist, key, token)
        const toast = this.$createToast({
          txt: '上传中...',
          mask: true
        })
        toast.show()
        const observe = {
          next (res) {
            console.log('已上传大小，单位为字节：' + res.total.loaded)
            console.log('本次上传的总量控制信息，单位为字节：' + res.total.size)
            console.log('当前上传进度，范围：0～100：' + res.total.percent)
          },
          error (err) {
            console.log(err.message)
            toast.hide()
            this.toast = this.$createToast({
              txt: '上传失败',
              type: 'error',
              time: 1000
            })
            this.toast.show()
          },
          complete: (res) => {
            // 完成后的操作
            // 上传成功以后会返回key 和 hash  key就是文件名了！
            this.imgs.push(qiniuUrl + res.key)
            toast.hide()
          }
        }
        observable.subscribe(observe) // 上传开始
      })
    },
    async getToken () {
      if (qinToken) return qinToken
      const res = await getQinToken()
      qinToken = res.obj
      return res.obj
    },
    async loadConfig () {
      const res = await getRelationForSelf()
      const relationArr = res.obj.map((item) => {
        return {
          value: item.key,
          text: item.value
        }
      })
      this.fields[0].props.options = relationArr
      const purRes = await getPurpose()
      const purArr = purRes.obj.map((item) => {
        return {
          value: item.key,
          text: item.value
        }
      })
      this.fields[5].props.options = purArr
    }
  },
  created () {
    if(getKey() === '~a01akcbbc7aaao'){
      const phone = getCacheObject("__userPhone__")
      const userName = getCacheObject("__userName__")
      
      this.model.relation = "1";
      this.model.purpose = "0";
      this.hideRelationField = true
      this.hideAddressField = true
     
      if(phone) {
        this.model.relationPhone = phone
        // 将手机号字段设为只读
        this.fields[8].props.readonly = true
        this.fields[8].props.disabled = true
      }
      if(userName) {
        this.model.realname = userName
        // 将姓名字段设为只读
        this.fields[1].props.readonly = true
        this.fields[1].props.disabled = true
      }
    }
  },
  activated () {
    qinToken = null
    orderId = this.$route.query.id
    this.loadConfig()
    // console.log('B--activated')
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
.wrapper {
  position absolute
  left 0
  top 0
  width 100%
  height 100%
  overflow auto
  background-color #232829
  -webkit-overflow-scrolling : touch
  font-size 15px

}
.cube-form, .custom-button {
  background #272c2d
}
.custom-button {
  font-size 14px
  text-align right
  // padding-left 0
}
.cube-form-group, .custom-item {
  color white
}
.custom-item {
  &.border-bottom-1px::after {
    border-bottom none !important
  }
}
textarea {
  resize none
  display block
  width 340px
  resize none
  cursor pointer
  outline: none
  border 1PX solid rgba(255, 255, 255,0.1)
  background #272c2d
  color white
  font-size 16px
  margin 10px auto
  padding 10px
}
.cube-form-item {
  border-bottom 1PX solid rgba(255, 255, 255, 0.1)
  box-sizing border-box
}
.textfield {
  background white
}
>>>.cube-select {
  text-align right !important
  font-size 15px
}
>>>.cube-input-field {
  text-align right
  padding-right 15px !important
  font-size 15px
}
>>>.cube-form-label {
  width 160px
  font-size 15px
}
.small {
  >>>.cube-form-label {
    width 140px
  }
}
.single {
  >>>.cube-form-label {
    width 300px
  }
}
.single {
  >>>.cube-form-label {
    width 300px
  }
}
>>>.cube-input {
  background-color transparent !important
}
>>>.cube-input-field::-webkit-input-placeholder {
  color #ccc
}
.no-value {
  color #ccc
}
.image-box {
  display flex
  flex-wrap wrap
  margin 10px
  .img {
    position relative

    width 85px
    height 85px
    margin-right 5px
    margin-bottom 5px

    img {
      width 100%
      height 100%
      object-fit: cover
      border 1PX solid #bebebe
      box-sizing border-box
    }
    .del {
      display block
      position absolute
      right 2px
      top 2px
      width 28px
      height 28px
      font-size 25px
      line-height 30px
      text-align center
      opacity 0.7
      border-radius 5px
      background black
      box-shadow: 0 0 2px 2px #888888;
    }
  }
  .img:nth-child(4n){
    margin-right 0
  }
}

.submit-button {
  margin 0 10px
  margin-top 50px
  padding-bottom 50px
  .button {
    background-color yellow
    color #4a4a4a
    border-radius 30px
  }
}

</style>
